export default {
  props: {
    title: {
      type: String,
    },
    body: {
      type: String,
    },
    pricing: {
      type: Object,
    },
    button: {
      type: Object,
    },
    background: {
      type: Object,
    },
  },

  computed: {
    hasButton() {
      return this.button !== undefined && this.$i18n.locale === 'pt-br'
    },
  },
}
